import { useEffect, useState }     from 'preact/hooks';
import { createDirectus, graphql } from '@directus/sdk';

const useCustomPageTemplateData = (apikey, page) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPageData = async () => {
    const client = createDirectus(import.meta.env.VITE_DIRECTUS_API_URL).with(graphql());
    try {
      const result = await client.query(`
     query {
     rlx_retailer(filter: {rlx_api_key: {_eq: "${apikey}"}}) {
             retailer_name
             retailer_location
          }
      }`)
      setData(result);
      setIsLoading(false);
    } catch (error) {
      setError(error);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchPageData()
  }, [page]);

  return { data, isLoading, error };
};

export default useCustomPageTemplateData;
